import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    maxWidth: theme.space.basicDataMaxWidth,
    margin: '0 auto',
    marginBottom: 120,
    boxSizing: 'border-box',
  },
  pensionFundsInfoAlert: {
    marginBottom: 16,
  },
  remainingFundsAlert: {
    marginTop: 16,
    marginBottom: 16,
  },
  fundListFilter: {
    marginTop: 24,
  },
}), { name: 'SelectFunds' });
